import React from "react";
import {
  SimpleForm,
  TextInput,
  SelectInput,
  useTranslate,
  useResourceContext,
  required,
  minValue,
} from "react-admin";
import {
  Grid,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { MyToolbar } from "@/components/forms";
import { useIsEditMode } from "@/hooks/useIsEditMode";
import { parseNumericInput } from "@/utils/validation";
import { COMMUNICATION_CHANNEL_CHOICES } from "../constants";

const useValidationMessages = () => {
  const translate = useTranslate();
  return {
    selectChannelMsg: translate(
      "resources.default-pricing.validation.selectChannel",
    ),
    enterValidPriceMsg: translate(
      "resources.default-pricing.validation.enterValidPrice",
    ),
  };
};

export const DefaultPricingForm: React.FC = () => {
  const translate = useTranslate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const resource = useResourceContext();
  const isEdit = useIsEditMode();
  const { selectChannelMsg, enterValidPriceMsg } = useValidationMessages();
  const validPriceFor =
    () => (value: number | string | undefined) =>
      value !== undefined && value !== "" && Number(value) < 0
        ? enterValidPriceMsg
        : undefined;

  return (
    <SimpleForm
      toolbar={<MyToolbar resource={resource} />}
      mode="all"
      reValidateMode="onChange"
      criteriaMode="all"
      shouldFocusError
      sx={{
        display: "flex",
        flexDirection: "column",
        pb: isMobile ? 10 : 0,
      }}
    >
      <Grid container spacing={{ xs: 1.5, sm: 2 }}>
        <Grid item xs={12} md={6}>
          <SelectInput
            source="communicationChannel"
            label={translate(
              "resources.default-pricing.fields.communicationChannel",
            )}
            choices={COMMUNICATION_CHANNEL_CHOICES}
            validate={required(selectChannelMsg)}
            fullWidth
            sx={{ mt: 0 }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextInput
            source="amount"
            label={translate("resources.default-pricing.fields.amount")}
            type="number"
            parse={parseNumericInput}
            validate={[
              required(enterValidPriceMsg),
              minValue(0, enterValidPriceMsg),
              validPriceFor(),
            ]}
            fullWidth
            autoFocus={!isEdit}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
      </Grid>
    </SimpleForm>
  );
};

export default DefaultPricingForm;
